import type { StacksResults, StacksStatus } from "../../shared/stacks.js";
export const demoStacksStatus: StacksStatus = {
  state: "ready",
  checkedAt: "2026-09-21T05:00:00Z",
  warmPercent: 100,
  meta: { num_docs: 125000, sources: ["Illustrative demo index"], snapshots: ["demo-2026-09"] }
};
export const demoStacksResults: StacksResults = {
  ms: 42,
  results: [
    {
      score: 0.94,
      bm25: 12.8,
      fields: {
        title: "An illustrative study of citation verification",
        authors: ["Alex Example", "Sam Example"],
        year: 2025,
        source: "Demo data",
        doi: "10.0000/demo-only"
      },
      agreement: { title: 0.98 },
      comparison: { title: { status: "corroborated", score: 0.98, unmatched_tokens: [] } }
    }
  ]
};

/** A fuller, illustrative response for the demo console: one strong record and
 *  two weaker candidates, so every evidence state is visible. As in the engine,
 *  unmatched_tokens are record words absent from the citation, and are empty
 *  for corroborated fields. */
export const demoStacksRichResults: StacksResults = {
  ms: 57,
  results: [
    {
      score: 0.94,
      bm25: 12.8,
      fields: {
        title: "An illustrative study of citation verification",
        authors: ["Alex Example", "Sam Example"],
        year: 2025,
        venue: "Journal of Demonstration Studies",
        volume: "3",
        issue: "2",
        first_page: "10",
        last_page: "20",
        source: "Demo data",
        doi: "10.0000/demo-only"
      },
      agreement: { title: 0.98, authors: 1, year: 1, venue: 0.62, volume: 1, first_page: 1 },
      comparison: {
        title: { status: "corroborated", score: 0.98, unmatched_tokens: [] },
        authors: { status: "corroborated", score: 1, unmatched_tokens: [] },
        year: { status: "corroborated", score: 1, unmatched_tokens: [] },
        venue: { status: "partial", score: 0.62, unmatched_tokens: ["demo"] },
        volume: { status: "corroborated", score: 1, unmatched_tokens: [] },
        first_page: { status: "corroborated", score: 1, unmatched_tokens: [] }
      }
    },
    {
      score: 0.71,
      bm25: 10.1,
      fields: {
        title: "Illustrative studies of citation verification in practice",
        authors: ["Alex Example"],
        year: 2023,
        venue: "Proceedings of the Demo Workshop",
        source: "Demo data"
      },
      agreement: { title: 0.81, authors: 0.5, year: 0 },
      comparison: {
        title: { status: "partial", score: 0.81, unmatched_tokens: ["in", "practice"] },
        authors: { status: "partial", score: 0.5, unmatched_tokens: ["alex"] },
        year: { status: "conflict", score: 0, unmatched_tokens: ["2023"] },
        venue: {
          status: "not_observed",
          score: 0,
          unmatched_tokens: ["proceedings", "the", "workshop"]
        }
      }
    },
    {
      score: 0.38,
      bm25: 6.4,
      fields: {
        title: "Verification of citations: a survey",
        authors: ["Jordan Sample"],
        year: 2025,
        source: "Demo data",
        isbn: "978-0-00-000000-0"
      },
      agreement: { title: 0.34, authors: 0, year: 1 },
      comparison: {
        title: {
          status: "conflict",
          score: 0.34,
          unmatched_tokens: ["citations", "survey"]
        },
        authors: { status: "conflict", score: 0, unmatched_tokens: ["jordan", "sample"] },
        year: { status: "corroborated", score: 1, unmatched_tokens: [] }
      }
    }
  ]
};
